// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "h1[data-v-022e5c1c] {\n  color: var(--h1HeaderFontColor, var(--text-gray-400));\n  font-family: var(--h1HeaderFontTypeface, inherit);\n  font-weight: var(--h1HeaderFontWeight, 700);\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
